import type { FC } from "react";

import { HostConfigurationsSearchForm } from "src/app/features/HostConfiguration/components/forms/HostConfigurationsSearchForm";
import { HostConfigurationsTable } from "src/app/features/HostConfiguration/components/tables/HostConfigurationsTable";
import type { HostConfigurationEntity } from "src/app/features/HostConfiguration/types/HostConfigurationEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const HostConfigurationsPage: FC<NoneOwnProps> = () => {
    const table = <HostConfigurationsTable />;
    const searchForm = <HostConfigurationsSearchForm />;
    const hasAccess = canAccess(ResourceName.HOST_CONFIGURATIONS, "canRead");

    return (
        <PageLayout name="hostConfigurationsXml_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.hostConfigurations" />
                    <ResourceManager<HostConfigurationEntity>
                        useDataGroup
                        dataMapperKey="hostConfigurationsTableData"
                        resource={ResourceName.HOST_CONFIGURATIONS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
